import type { TokenPayload } from "@packsize/identity-api-sdk";
import { createContext } from "react";

interface TokenContextProps {
	token: string | null;
	bearerToken: string | null;
	decodedToken: TokenPayload | null;
	tokenValid: boolean | undefined;
	setToken: (token: string) => void;
	processToken: (token: string) => Promise<boolean>;
	clearToken: () => void;
}

const initialState: TokenContextProps = {
	token: null,
	bearerToken: null,
	decodedToken: null,
	tokenValid: undefined,
	setToken: () => undefined,
	processToken: () => Promise.resolve(true),
	clearToken: () => undefined,
};

export const TokenContext = createContext<TokenContextProps>(initialState);
